import { useState } from 'react';
import { useLang } from 'hooks/lang';

import { Button, Modal, RadioInput, Row, ComponentOrNode } from 'components/Blocks';
import { DownloadIcon } from 'components/Icons';

import { ProjectOptionOverlayProps } from '../createProjectOption';
import { useProjectOption } from '../options';

export function ChoosePDFModal(props: ProjectOptionOverlayProps) {
  const { t } = useLang();

  const [pdf, setPDF] = useState('');

  const basePDF = useProjectOption('DOWNLOAD_SIMPLE_PDF');
  const breakdownPDF = useProjectOption('DOWNLOAD_SERVICE_BREAKDOWN_PDF');

  const configRef = pdf === 'DOWNLOAD_SIMPLE_PDF' ? basePDF : breakdownPDF;

  return (
    <Modal allowEscape {...props} title={t('select-project-pdf-type')} width="min(90vw, 460px)">
      <RadioInput
        value={pdf}
        onChangeDirect={setPDF}
        className="w-full shrink rounded-md border p-2 text-sm transition-colors hover:bg-hover"
        selectedClassName="border-primary text-primary"
        alignItems="stretch"
        options={[
          { label: t('pdf-direct-costs'), value: 'DOWNLOAD_SIMPLE_PDF' },
          { label: t('pdf-breakdown'), value: 'DOWNLOAD_SERVICE_BREAKDOWN_PDF' },
        ]}
        render={({ value, label }) => (
          <Row gap="2">
            <ComponentOrNode
              target={value === 'DOWNLOAD_SIMPLE_PDF' ? basePDF.Icon : breakdownPDF.Icon}
              size={24}
            />

            <span>{label}</span>
          </Row>
        )}
      />

      <Button disabled={!pdf} onClick={configRef.action} loading={configRef.loading}>
        <DownloadIcon />
        {t('download')}
      </Button>
    </Modal>
  );
}
